module.exports = __webpack_public_path__ + "static/img/level_bg_off.913c5864.png";